import React from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

import { submissionMillis } from "../../hooks/ContactSubmissionsHook";

const formatDate = (ts) => {
  const ms = submissionMillis(ts);
  return ms ? new Date(ms).toLocaleString() : "—";
};

const Field = ({ label, value, full }) => (
  <Grid item xs={full ? 12 : 6}>
    <Typography sx={labelStyles}>{label}</Typography>
    <Typography sx={{ ...valueStyles, whiteSpace: full ? "pre-wrap" : "normal" }}>
      {value || "—"}
    </Typography>
  </Grid>
);

const ContactSubmissionModal = ({ submission, open, onClose }) => {
  if (!submission) return null;
  const s = submission;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={titleStyles}>
        Contact Submission
        <Chip
          size="small"
          sx={{ ml: 1.5 }}
          color={s.status === "read" ? "default" : "primary"}
          label={s.status || "new"}
        />
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Field label="First Name" value={s.firstName} />
          <Field label="Last Name" value={s.lastName} />
          <Field label="Email" value={s.email} />
          <Field label="Phone" value={s.phone} />
          <Field label="Organization" value={s.organization} full />
          <Field label="Message" value={s.message} full />
          <Field label="Form" value={s.formName} />
          <Field label="Page" value={s.pagePath} />
          <Field label="Submitted" value={formatDate(s.createdAt)} full />
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} style={closeStyles}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactSubmissionModal;

const titleStyles = {
  fontFamily: "Avenir Book, sans-serif",
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
};

const labelStyles = {
  fontFamily: "Avenir Book, sans-serif",
  fontWeight: 600,
  fontSize: 12,
  color: "#0A0A0AAB",
  mb: 0.5,
};

const valueStyles = {
  fontFamily: "Avenir Book, sans-serif",
  fontSize: 14,
  color: "#020303",
};

const closeStyles = {
  textTransform: "none",
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
};
